var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "compare-wrapper" }, [
    !_vm.loaded
      ? _c(
          "div",
          {
            staticClass: "compare-container loading",
            staticStyle: { "min-height": "1000px" },
          },
          [
            _c("div", { staticClass: "msg" }, [
              _c("h1", [
                _vm._v(_vm._s(_vm.translations.compare01) + " "),
                _c("i", { staticClass: "fa fa-spin fa-circle-o-notch" }),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.translations.compare02))]),
            ]),
          ]
        )
      : _vm.loaded && (_vm.count <= 0 || _vm.dataObjects.length <= 0)
      ? _c("div", [_c("h1", [_vm._v(_vm._s(_vm.translations.compare03))])])
      : _c(
          "div",
          {
            staticClass: "compare",
            staticStyle: { "min-height": "1000px" },
            attrs: { id: "compare" },
          },
          [
            _c("h1", [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.translations.compare04) },
              }),
              _vm._v(" (" + _vm._s(_vm.count) + ")"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.count > 1 && _vm.loaded,
                    expression: "count > 1 && loaded",
                  },
                ],
                staticClass: "d-all",
                staticStyle: { "padding-top": "20px" },
              },
              [
                _c("p", { on: { click: _vm.deleteAll } }, [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" " + _vm._s(_vm.translations.compare05)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dataObjects && _vm.loaded && _vm.count,
                    expression: "dataObjects && loaded && count",
                  },
                ],
                staticClass: "compare-grid-wrap sticky",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "compare-grid",
                    style: { "--cols": _vm.count },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "rowx grad" },
                      [
                        _c("div", { staticClass: "cell legend grad" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.translations.compare06)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataObjects, function (item) {
                          return _c(
                            "div",
                            { key: item.id + "-title", staticClass: "cell" },
                            [
                              item.data.variation.name &&
                              item.data.variation.name != ""
                                ? _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(item.data.variation.name)),
                                  ])
                                : _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(item.data.texts.name1)),
                                  ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "img" }, [
                                _c("span", [
                                  item.data.images.variation.length
                                    ? _c("img", {
                                        staticClass: "lazyload",
                                        attrs: {
                                          "data-src":
                                            item.data.images.variation[0]
                                              .urlMiddle,
                                          alt: "",
                                        },
                                      })
                                    : _c("img", {
                                        staticClass: "lazyload",
                                        attrs: {
                                          "data-src":
                                            item.data.images.all[0].urlMiddle,
                                          alt: "",
                                        },
                                      }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "price" }, [
                                item.data.prices.specialOffer &&
                                item.data.prices.specialOffer.price.value <
                                  item.data.prices.default.unitPrice.value
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            item.data.prices.specialOffer.price
                                              .formatted
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.data.prices.default.unitPrice
                                            .formatted
                                        )
                                      ),
                                    ]),
                                _vm._v(" "),
                                item.data.prices.specialOffer
                                  ? _c("del", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              item.data.prices.default.unitPrice
                                                .formatted,
                                              true
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : item.data.prices.rrp &&
                                    item.data.prices.rrp.unitPrice.value > 0 &&
                                    item.data.prices.rrp.unitPrice.value >
                                      item.data.prices.default.unitPrice.value
                                  ? _c("del", { staticClass: "rrp" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            item.data.prices.rrp.unitPrice
                                              .formatted
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "c2a-btns" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn grad",
                                    attrs: {
                                      href: _vm._f("itemURL")(item.data),
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.translations.compare07))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn rmv",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(item.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.translations.compare08))]
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dataObjects && _vm.loaded && _vm.count,
                    expression: "dataObjects && loaded && count",
                  },
                ],
                ref: "scroller",
                staticClass: "compare-grid-wrap",
              },
              [
                _c(
                  "div",
                  {
                    ref: "grid",
                    staticClass: "compare-grid",
                    style: { "--cols": _vm.count },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "rowx images" },
                      [
                        _c("div", { staticClass: "cell legend" }, [
                          _vm._v(" "),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataObjects, function (item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "cell" },
                            [
                              _c("span", { staticClass: "img" }, [
                                _c("span", [
                                  item.data.images.variation.length
                                    ? _c("img", {
                                        staticClass: "lazyload",
                                        attrs: {
                                          "data-src":
                                            item.data.images.variation[0]
                                              .urlMiddle,
                                          alt: "",
                                        },
                                      })
                                    : _c("img", {
                                        staticClass: "lazyload",
                                        attrs: {
                                          "data-src":
                                            item.data.images.all[0].urlMiddle,
                                          alt: "",
                                        },
                                      }),
                                ]),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rowx product" },
                      [
                        _c("div", { staticClass: "cell legend" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.translations.compare06)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataObjects, function (item) {
                          return _c(
                            "div",
                            { key: item.id + "-title", staticClass: "cell" },
                            [
                              item.data.variation.name &&
                              item.data.variation.name != ""
                                ? _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(item.data.variation.name)),
                                  ])
                                : _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(item.data.texts.name1)),
                                  ]),
                              _vm._v(" "),
                              _vm._l(
                                item.data.variationProperties,
                                function (varProp) {
                                  return item.data.variationProperties &&
                                    varProp.id == 18
                                    ? [
                                        _vm._l(
                                          varProp.properties,
                                          function (varProp) {
                                            return varProp.id == 99 &&
                                              varProp.values &&
                                              varProp.values.value != ""
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "sub small",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          varProp.values.value
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e()
                                          }
                                        ),
                                      ]
                                    : _vm._e()
                                }
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "c2a-btns" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn grad",
                                    attrs: {
                                      href: _vm._f("itemURL")(item.data),
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.translations.compare07))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn rmv",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(item.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.translations.compare08))]
                                ),
                              ]),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rowx price" },
                      [
                        _c("div", { staticClass: "cell legend" }, [
                          _vm._v(_vm._s(_vm.translations.compare09)),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataObjects, function (item) {
                          return _c(
                            "div",
                            { key: item.id + "-price", staticClass: "cell" },
                            [
                              _c("span", [
                                item.data.prices.specialOffer &&
                                item.data.prices.specialOffer.price.value <
                                  item.data.prices.default.unitPrice.value
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            item.data.prices.specialOffer.price
                                              .formatted
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.data.prices.default.unitPrice
                                            .formatted
                                        )
                                      ),
                                    ]),
                                _vm._v(" "),
                                item.data.prices.specialOffer
                                  ? _c("del", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm._f("itemCrossPrice")(
                                              item.data.prices.default.unitPrice
                                                .formatted,
                                              true
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : item.data.prices.rrp &&
                                    item.data.prices.rrp.unitPrice.value > 0 &&
                                    item.data.prices.rrp.unitPrice.value >
                                      item.data.prices.default.unitPrice.value
                                  ? _c("del", { staticClass: "rrp" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            item.data.prices.rrp.unitPrice
                                              .formatted
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rowx ratings" },
                      [
                        _c("div", { staticClass: "cell legend" }, [
                          _vm._v(_vm._s(_vm.translations.compare10)),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataObjects, function (item) {
                          return _c(
                            "div",
                            { key: item.id + "-rating", staticClass: "cell" },
                            [
                              _c(
                                "span",
                                { staticClass: "rating-wrapper" },
                                [
                                  item.data.item.feedbackCount
                                    ? [
                                        _c("span", { staticClass: "rating" }, [
                                          _c(
                                            "span",
                                            { staticClass: "blank" },
                                            _vm._l(5, function (n) {
                                              return _c("i", {
                                                key: "b" + n,
                                                staticClass: "fa fa-star",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              })
                                            }),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "rate",
                                              style: {
                                                width:
                                                  item.data.item
                                                    .feedbackDecimal *
                                                    20 +
                                                  "%",
                                              },
                                            },
                                            _vm._l(5, function (n) {
                                              return _c("i", {
                                                key: "r" + n,
                                                staticClass: "fa fa-star",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              })
                                            }),
                                            0
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                item.data.item.feedbackCount
                                              ) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    : [
                                        _c(
                                          "span",
                                          { staticClass: "rating no" },
                                          [_vm._v("-")]
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rowx av" },
                      [
                        _c("div", { staticClass: "cell legend" }, [
                          _vm._v(_vm._s(_vm.translations.compare11)),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataObjects, function (item) {
                          return _c(
                            "div",
                            { key: item.id + "-avail", staticClass: "cell" },
                            [
                              item.data.variation.availability &&
                              item.data.variation.availability.names &&
                              item.data.variation.availability.names.name
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        "av" +
                                        item.data.variation.availability.id,
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            item.data.variation.availability.names.name.replace(
                                              "Lieferzeit ",
                                              ""
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.groupedVariationProperties, function (group) {
                      return _c(
                        "div",
                        {
                          key: "group-" + group.groupName,
                          staticClass: "group-block",
                        },
                        [
                          _c("div", { staticClass: "rowx headline grad" }, [
                            _c(
                              "div",
                              { staticClass: "cell legend headline-cell grad" },
                              [_c("strong", [_vm._v(_vm._s(group.groupName))])]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(group.props, function (propName) {
                            return _c(
                              "div",
                              {
                                key: "prop-" + propName,
                                staticClass: "rowx props",
                              },
                              [
                                _c("div", { staticClass: "cell legend" }, [
                                  _c("span", [_vm._v(_vm._s(propName))]),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.dataObjects, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.id + "-" + propName,
                                      staticClass: "cell",
                                    },
                                    [
                                      _vm.getPropertyValue(
                                        item,
                                        group.groupId,
                                        propName
                                      ) === "Ja"
                                        ? [
                                            _c("i", {
                                              staticClass: "fa fa-check",
                                            }),
                                          ]
                                        : _vm.getPropertyValue(
                                            item,
                                            group.groupId,
                                            propName
                                          ) === "Nein"
                                        ? [
                                            _c("i", {
                                              staticClass: "fa fa-times",
                                            }),
                                          ]
                                        : [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getPropertyValue(
                                                    item,
                                                    group.groupId,
                                                    propName
                                                  ) || "-"
                                                ),
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  )
                                }),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.count > 1 && _vm.loaded,
                    expression: "count > 1 && loaded",
                  },
                ],
                staticClass: "d-all",
                staticStyle: { "padding-top": "20px" },
              },
              [
                _c("p", { on: { click: _vm.deleteAll } }, [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" " + _vm._s(_vm.translations.compare12)),
                ]),
              ]
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }